<template>
    <div class="d-flex align-items-center">
        <img class="flag" :src="flag">
        <!--<select class="form-select languageSelect" aria-label="Language select" v-model="language" @change="switchLanguage">
            <switch-language v-for="l in languages" :shortcut="l.name_iso" :value="l.name_iso" :flag="l.icon" :selected="l.is_default === 1"></switch-language>
        </select>-->
        <select class="form-select languageSelect" aria-label="Language select" v-model="language" @change="switchLanguage">
            <switch-language v-for="(item, index) in langRoutes" :shortcut="item.name_iso" :value="index" :flag="item.icon"
                             :selected="item.is_current === 1 ? 1 : 0" :route="item.route"></switch-language>
        </select>
    </div>
</template>

<script>
import axios from 'axios'
import {inject, onMounted, reactive, toRefs, ref } from "vue"
import SwitchLanguage from "../buttons/SwitchLanguage"

export default {

    components: {
        SwitchLanguage,
    },

    props: ['langRoutes'],

    setup(props) {

        const state = reactive({
            show: false,
            escToClose: true,
            csrf: null,
            language: null,
            languages: null,
            flag: null,
        })

        const emitter = inject('emitter')

        onMounted( () => {
            //getLanguage("true");
            //getLanguage("false");
            for (var i in props.langRoutes) {
                if (props.langRoutes[i].is_current === 1) {
                    // console.log(props.langRoutes[i])
                    state.language = props.langRoutes[i].route
                    state.flag = props.langRoutes[i].icon
                    break
                }
            }
            console.log(state.language)
        })

        /*function getLanguage(all) {
            axios.get('/getLanguage', {
                params: {
                    all: all
                }
            }).then( response => {
                if (all == "true") {
                    state.languages = response.data;
                } else {
                    state.flag = response.data.flag
                    state.language = response.data.name_iso;
                }
            }).catch( error => console.error(error) )
        }*/

        function switchLanguage() {
            window.location.href = state.language;

            /*axios.put('/setLanguage', {
                shortcut: state.language,
            })
                .then( response => {
                    location.reload();
                })
                .catch( error => console.error(error) )*/
        }

        return {
            switchLanguage,
            ...toRefs(state),
        }
    }
}
</script>
